module.exports = __webpack_public_path__ + "static/media/logo-bamboo.d5e2da38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-bamboo.png
// module id = 1296
// module chunks = 17